/**
 * Site footer — persistent across all routes via
 * {@link ../../app.component.ts}.
 *
 * Mostly presentational: `currentYear` is computed once at construction
 * so the copyright line flips automatically on January 1. The footer
 * also exposes a "Cookie Preferences" entry-point that reopens the
 * consent banner via {@link CookieConsentService.reopen} — required by
 * GDPR Art. 7(3) so withdrawing consent is as easy as giving it.
 */
import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { CookieConsentService } from '../../services/cookie-consent.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  private readonly cookies = inject(CookieConsentService);

  currentYear = new Date().getFullYear();

  openCookiePreferences(): void {
    this.cookies.reopen();
  }
}
